import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Provider} from "react-redux";
import {applyMiddleware, compose, createStore} from "redux";
import thunk from "redux-thunk";
import {rootReducer} from "./redux/rootReducer";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import {Loader} from "./elements/loader";

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        supportedLngs: ['en', 'uz', 'ru'],
        fallbackLng: 'en',
        detection: {
            order: ['path', 'cookie', 'htmlTag', 'localstorage', 'subdomain'],
            caches: ['cookie'],
        },
        backend: {
            loadPath: '/assets/locales/{{lng}}/translation.json'
        },
    })

const store = createStore(rootReducer, compose(
    applyMiddleware(
        thunk
    )
))

const loading = <Loader/>

window.addEventListener('load', async () => {
    if ('serviceWorker' in navigator) {
        try {
            await navigator.serviceWorker.register('/sw.js')
        } catch (e) {
            console.log(e)}
    }
})

const app = (

    <Suspense fallback={loading}>
        <Provider store={store}>
            <App />
        </Provider>
    </Suspense>
)

ReactDOM.render( app, document.getElementById('root'));
